
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { Card, Table, Tooltip, Space, } from "antd";
import IconButton from "components/ui/Button/IconButton";
import moment from "moment";
import { ImagePaths } from "utils/ImagePath";
import ConfigurationFilter from "../ConfigurationFilter";
import CommonTblHeader from "components/common/CommonTblHeader";
import ToastMsg from "components/common/ToastMsg";
import useApiData from "components/common/useGetApiData";
import { getHolidaySetupPagination } from "hooks/api/configurationApi/holidaySetupApi";
import { HOLIDAY_SETUP } from "constants";
import {checkUserPermissionFunc, deleteDraftItemsById} from "components/common/CommonFuntion";
import { CommonDeletePopup } from 'components/common/CommonComponent';
import useApiMethods from "hooks/apiConfig/method/apiMethods";
import { NEW_HOLIDAY_SETUP } from "constant";

const initialData = {
  holiday_code: "",
  holiday_name: "",
  holiday_type: "",
  holiday_is_active: "",
}

function HolidaySetup() {
  let query = "";
  let queryRef = useRef("");
  const pageSize = 10;
  const authtoken = sessionStorage.getItem("token");

  const [editVisible, setEditVisible] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState();
  const [searchText, setSearchText] = useState("");
  const [dataUpdated, setDataUpdated] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [sorting, setSorting] = useState("");
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterDatas, setFilterDatas] = useState({ initialData });
  const [reorderedColumns, setReorderedColumns] = useState([]);
  const [isDraft, setIsDraft] = useState(false);
  const [deleteItem, setDeleteClicked] = useState({ id: undefined, isDeleteClicked: false });
  const tableContainerHeight = isDraft ? "77.5vh" : "72vh";

  const navigate = useNavigate();

  useEffect(() => {
    if (!authtoken) {
      window.location.href = "/";
    }
  }, [authtoken]);

  const userPermission = checkUserPermissionFunc("configuration", "Holiday", "SubMenu");

  const queryString =
    "?page_no=" + pageNo +
    "&page_size=" + pageSize +
    "&code=" + (filterDatas.holiday_code ? filterDatas.holiday_code : "") +
    "&holiday_name=" + (filterDatas.holiday_name ? filterDatas.holiday_name : "") +
    "&holiday_type=" + (filterDatas.holiday_type ? filterDatas.holiday_type : "") +
    "&is_active=" + (filterDatas.holiday_is_active !== undefined ? filterDatas.holiday_is_active : "") +
    "&search=" + searchText + (sorting ? `&${sorting}` : "");

  // const [data, pageInfo, loading, _message, refetch] = useApiData(getHolidaySetupPagination, {
  //   pageNo,
  //   pageSize,
  //   queryString,
  //   searchText,
  //   sorting
  // });

  const { fetch, update } = useApiMethods();
  const [data, setData] = useState([]);
  const [pageInfo, setPageInfo] = useState([])
  const [loading, setLoading] = useState(false);
  const [filter, setFilter]=useState({pageNo:'', pageSize:'', query:'', search:'', sorting:''})

  const fetchHoliday = async () => {        
    const res = await fetch(
      NEW_HOLIDAY_SETUP, 
      filter,
      setLoading
    );
    if (res?.status) {
      setData(res.data.result);
      setPageInfo({
        pageNo: res.data.page_no,
        pageSize: res.data.page_size,
        totalCount: res.data.total_count,
        noOfPages: res.data.no_of_pages,
      });
    }
  };

  useEffect(() => {
    if (!authtoken) {
      window.location.href = "/";
    }
    fetchHoliday();
  }, [filter, editVisible]);

  // useEffect(() => {
  //   if (_message && _message.isErrorMsg && _message.errorMsgText) {
  //     ToastMsg('error', _message.errorMsgText);
  //   }
  // }, [_message, _message.errorMsgText]);

  const addClick = () => {
    setEditVisible(false);
    setSelectedDetails({});
    navigate('/configuration/holiday/add', { state: { fromEdit: false, editDetails: {}, isActive: userPermission?.active !== undefined ? userPermission?.active : true } });
  };

  const handleEditClick = (details) => {
    if (editVisible && Object.keys(selectedDetails).length > 0) {
      ToastMsg("warning", "Please cancel the existing edit operation!")
    }
    else if (!editVisible) {
      setEditVisible(true);
      navigate('/configuration/holiday/add', { state: { fromEdit: true, editDetails: details, isActive: userPermission?.active !== undefined ? userPermission?.active : true } });
      setSelectedDetails(details);
    }
  };

  const handleSearch = () => {
    setEditVisible(false)
    setSelectedDetails({});
    setPageNo(1);
    setFilter(1,
      pageSize,
      queryString,
      searchText,
      sorting);
    setDataUpdated(!dataUpdated);
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const sortorder = `sort=${sorter.order === "descend" ? "desc" : sorter.order === "ascend" ? "asc" : ""}&`
    const sortQuery = sorter.order ? `${sortorder}column=${sorter.columnKey}` : ""
    queryRef.current = isDraft ? `is_draft=True` : "" + queryString;
    setFilter((prevFilter) => ({
      ...prevFilter, 
      pageNo: pagination.current, 
      pageSize: pagination.pageSize || prevFilter.pageSize, 
      query: queryRef.current, 
      sorting: sortQuery,
    }));
    setSorting(sortQuery)
  }

  // filter start
  const renderFilter = (data) => {
    setFilterDatas((prevdata) => ({ ...prevdata, ...data }));
    setPageNo(1);
    setFilter((prevFilter) => ({
      ...prevFilter, 
      pageNo: 1, 
      pageSize: pageSize || prevFilter.pageSize, 
      query: `code=${data.holiday_code ? data.holiday_code : ""}&holiday_name=${data.holiday_name ? data.holiday_name : ""}&holiday_type=${data.holiday_type ? data.holiday_type : ""}&is_active=${data.holiday_is_active !== undefined ? data.holiday_is_active : ""}`,
      search: searchText,
      sorting: sorting,
    }));
    setFilterVisible(false);
  }

  const ClosePopUp = () => {
    setFilterVisible(false);
  }

  const clearFilter = () => {
    setFilterDatas(initialData);
    setPageNo(1);
    setFilter(1,
      pageSize,
      queryString,
      searchText,
      sorting);
  }
  //filter end

  const columns = [
    {
      title: "Holiday Code",
      dataIndex: "code",
      key: "code",
      sorter: true,
      width: "14.28%",
      fixed: "left",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (record.code?.length > 20 ?
          <Tooltip title={record.code}>{<span style={{ color: colors }}>{record.code?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={{ color: colors }}>{record.code ? record.code : "-"}</p>)
      }
    },
    {
      title: "Holiday Name List",
      dataIndex: "holiday_name",
      key: "holiday_name",
      sorter: true,
      width: "17.96%",
      fixed: "left",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (record.holiday_name?.length > 20 ?
          <Tooltip title={record.holiday_name}>{<span style={{ color: colors }}>{record.holiday_name?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={{ color: colors }}>{record.holiday_name ? record.holiday_name : "-"}</p>)
      }
    },
    {
      title: "Holiday Type ",
      dataIndex: "holiday_type",
      key: "holiday_type",
      sorter: true,
      width: "14.28%",
      fixed: "left",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (record.holiday_type?.length > 20 ?
          <Tooltip title={record.holiday_type}>{<span style={{ color: colors, textTransform: "capitalize" }}>{record.holiday_type?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={{ color: colors, textTransform: "capitalize" }}>{record.holiday_type ? record.holiday_type : "-"}</p>)
      }
    },
    {
      title: "Date",
      key: "date",
      dataIndex: "date",
      sorter: true,
      width: "14.28%",
      render: (_, record) =>
      (
        <span style={{ color: record.is_active === true ? "black" : "#CACACA" }}>
          {record.date ? moment(record.date, "YYYY-MM-DD").format("MMMM D, YYYY") : "-"}
        </span>
      ),
      align: "center",
      fixed: "left",
    },
    {
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
      sorter: true,
      width: "17.88%",
      fixed: "left",
      render: (_, record) =>
      (record?.notes?.length > 28 ?
        <Tooltip title={record?.notes}>{<span style={{ color: record?.is_active ? "black" : "#CACACA" }}>{record?.notes?.slice(0, 25) + "..."}</span>}</Tooltip>
        : <p style={{ color: record?.is_active ? "black" : "#CACACA" }}>{record?.notes ? record?.notes : "-"}</p>),
      fixed: 'left',
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: true,
      width: "12.28%",
      render: (_, record) =>
        record.is_active === true ? (
          <span style={{ color: "black" }}>Active</span>
        ) : (
          <span style={{ color: "#CACACA" }}>Inactive</span>
        ),
      align: 'center',
      fixed: "left",
    },
  ];
  if (userPermission?.edit) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "9%",
      align: 'center',
      fixed: "left",
      render: (_, record) => (
        <div className="flex justify-center items-center">
          <Space size={"middle"}>
            <IconButton
              title="Edit"
              icon={<img src={ImagePaths.edit.default} alt="Edit" />}
              onClick={() => (loading ? "" : handleEditClick(record))}
              testID={'ug_btn_edit'}
            />
            {record.is_draft === true ?
              <IconButton
                title="Delete"
                icon={<img src={ImagePaths.delete.default} alt="Delete" />}
                onClick={() => (loading ? "" : handleDeleteClicked(record?.id))}
                testID={'ug_btn_delete'}
              /> : null}
          </Space>
        </div>
      ),
    })
  }

  //draft delete start
  const handleDeleteClicked = (id) => {
    setDeleteClicked((prevdata) => ({
      ...prevdata,
      id: id,
      isDeleteClicked: true
    }));
  }

  const handleCancelBtn = () => {
    setDeleteClicked((prevdata) => ({
      ...prevdata,
      id: undefined,
      isDeleteClicked: false
    }));
  }

  const handleDeleteBtn = async (id) => {
    try {
      // Create FormData object
      const formData = new FormData();
      formData.append("id", id);
      formData.append("is_active", false);
  
      if (isDraft) {
        formData.append("draft_delete", true);
        formData.append("is_draft", true);
      }
  
      // Make the API call
      const response = await update(NEW_HOLIDAY_SETUP, formData);
  
      if (response?.status) {
        ToastMsg("success", "Holiday setup deleted successfully.");
        handleDraft();
      } else {
        ToastMsg("error", response.message || "Failed to delete the Holiday setup.");
      }
    }  catch (error) {
      ToastMsg("error", error.message);
    } finally {
      handleCancelBtn();
    }
  }//draft delete end

  const handleFilter = () => {
    setFilterVisible(true)
  }

  const handleDraft = () => {
    setIsDraft(true);
    setFilterVisible(false);
    setSorting("");
    setPageNo(1);
    queryRef.current = `is_draft=True`
    setFilter((prevFilter) => ({
      ...prevFilter, 
      pageNo: 1, 
      query: queryRef.current, 
      sorting: "",
    }));
  }

  const handleBackToHome = () => {
    setIsDraft(false);
    setSorting("");
    setPageNo(1);
    queryRef.current = "";
    setFilter(1,
      pageSize,
      queryRef.current,
      queryString,
      searchText,
      "");
  }

  const handleStateChanges = (search = "", reorderedList = []) => {
    setSearchText(search)
    setReorderedColumns(reorderedList)
  }

  const printData =
    "?page_no=" + pageNo +
    "&page_size=" + pageSize +
    "&code=" + (filterDatas.holiday_code ? filterDatas.holiday_code : "") +
    "&holiday_name=" + (filterDatas.holiday_name ? filterDatas.holiday_name : "") +
    "&holiday_type=" + (filterDatas.holiday_type ? filterDatas.holiday_type : "") +
    "&is_active=" + (filterDatas.holiday_is_active !== undefined ? filterDatas.holiday_is_active : "") +
    "&search=" + searchText + (sorting ? `&${sorting}` : "");

  const styles = {
    fltContainer: {
      border: "1px solid #cbcbcb",
      height: tableContainerHeight,
    },
  }

  return (
    <Card className="h-full overflow-hidden">
      <div className={"h-1/6"} >
        <CommonTblHeader pageName={"Holiday Setup"}
          pageInfo={pageInfo}
          handleSearch={handleSearch} selectedDetails={selectedDetails} addClick={addClick}
          onStateChange={handleStateChanges} handleFilter={handleFilter} columns={columns}
          handleDraft={handleDraft} isDraft={isDraft} handleBackToHome={handleBackToHome}
          url={NEW_HOLIDAY_SETUP} query={printData}
          isAddRequired = {userPermission?.add ? true : false}
          isDraftRequired = {userPermission?.draft ? true : false}
          testID = {'hs'}
        />
      </div>
      <div className="h-5/6 flex justify-center items-center  mt-1">
        {filterVisible ?
          <div className="w-1/4 mt-5" style={styles.fltContainer}>
            <ConfigurationFilter
              pageName={"HolidaySetup"}
              filterDatas={filterDatas}
              closeFilter={ClosePopUp}
              filteredData={renderFilter}
              clearData={clearFilter} />
          </div>
          : null}
        <div className={filterVisible ? "mt-5 w-3/4" : "mt-5 w-full"} style={styles.fltContainer}>
        <Table
          columns={reorderedColumns?.length > 0 ? reorderedColumns : columns}
          dataSource={data?.length > 0 ? data : null}
          loading={loading}
          style = {{"--table-container-height": tableContainerHeight}}
          scroll={{ y: `calc(${tableContainerHeight} - 140px)` }}
          onChange={handleTableChange}
          pagination={{
            style: { marginRight: 20, padding: 0 },
            defaultPageSize: pageSize,
            showSizeChanger: false,
            showQuickJumper: true,
            total: pageInfo?.totalCount ? pageInfo?.totalCount : 0,
            pageSizeOptions: ["10", "20", "30"],
            pageSize,
            defaultCurrent: pageNo,
          }}
          key={isDraft ? (dataUpdated ? "draftUpdated" : "draftNotUpdated") : (dataUpdated ? "updated" : "not-updated")}
        />
        </div>
      </div>
      {deleteItem.isDeleteClicked ? <CommonDeletePopup handleCancelBtn={handleCancelBtn} handleDeleteBtn={() => handleDeleteBtn(deleteItem.id)} /> : null}
    </Card>
  );
}

export default HolidaySetup;
